export const renderAllSidesToFiles = async ({
  pixelRatio = 1.5,
  quality = 1,
  skipRestore = false,
  selectedProduct,
  layerOptions,
  canvasStates,
  getBaseZoomDataURL,
  handleSetCanvasByLayer,
  waitForCanvasReady,
  saveCurrentCanvasState,
  setTexts,
  setUploadedImages,
  setStickers,
  setLayerColorMap,
  // setCurrentAttachType,
  // setSelectedLayerId,
  imageMap,
  previousState,
  ensureFocusAndLoadCanvas,
  // setSelectedTextId,
  // setSelectedImageId,
  // setSelectedStickerId,
  resetCanvasState,
}) => {
  // function restoreCanvasState(state = {}) {
  //   setTexts(state.texts || []);
  //   setUploadedImages(state.uploadedImages || []);
  //   setStickers(state.stickers || []);
  //   setLayerColorMap(state.layerColorMap || {});
  //   setCurrentAttachType(state.currentAttachType || null);
  //   setSelectedLayerId(state.selectedLayerId || null);
  //   setSelectedTextId(state.selectedTextId || null);
  //   setSelectedImageId(state.selectedImageId || null);
  //   setSelectedStickerId(state.selectedStickerId || null);
  // }

  const attachTypes = [1, 2, 4];
  const resultFiles = [];

  const validAttachItems = attachTypes
    .map((type) => selectedProduct?.attachments?.find((att) => att.attachType === type))
    .filter(Boolean);

  // Sử dụng reduce để chạy tuần tự
  await validAttachItems.reduce(async (prevPromise, item) => {
    await prevPromise;

    saveCurrentCanvasState();

    // ✅ Reset state trước mỗi lần chuyển mặt
    resetCanvasState();

    const matchedLayer = layerOptions.find(
      (l) => l.attachment?.encryptedId === item.encryptedId && l.layerType === item.attachType
    );
    const key = matchedLayer ? `${item.attachType}-${matchedLayer.layerId}` : null;
    const state = canvasStates[key];

    if (state) {
      setTexts(state.texts || []);
      setUploadedImages(state.uploadedImages || []);
      setStickers(state.stickers || []);
      setLayerColorMap(state.layerColorMap || {});
    }

    await ensureFocusAndLoadCanvas(item, {
      skipOverlay: true,
      skipOverlayGeneration: true, // ⬅ ngăn lặp vô hạn
    });

    await waitForCanvasReady();

    const url = getBaseZoomDataURL(pixelRatio, quality);
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer(); // thay vì blob()
    const file = new File([arrayBuffer], `side-${item.attachType}.png`, { type: "image/png" });
    // const debugUrl = URL.createObjectURL(file);
    // window.open(debugUrl);
    resultFiles.push(file);
  }, Promise.resolve());

  if (!skipRestore && previousState) {
    setTimeout(() => {
      resetCanvasState();
      // restoreCanvasState(previousState);
      const oldAttach = selectedProduct?.attachments?.find(
        (att) => att.attachType === previousState.currentAttachType
      );
      if (oldAttach && imageMap[oldAttach.encryptedId]) {
        handleSetCanvasByLayer(oldAttach, { skipReset: true });
      }
    }, 100);
  }

  return resultFiles;
};
